import { useEffect } from 'react';

// Cap per sessione: evita flood in caso di errore ripetuto in loop
const MAX_REPORTS_PER_SESSION = 5;
let reportCount = 0;
const reportedMessages = new Set<string>();

function report(context: string, message: string, source?: string) {
  if (reportCount >= MAX_REPORTS_PER_SESSION) return;
  // Stesso messaggio già inviato in questa sessione: salta
  if (reportedMessages.has(message)) return;
  reportedMessages.add(message);
  reportCount++;

  try {
    const sessionId = sessionStorage.getItem('tracking_session_id') || null;
    // sendBeacon non aspetta risposta e sopravvive all'unload della pagina
    const payload = JSON.stringify({
      sessionId,
      page: window.location.pathname,
      context,
      message: message.substring(0, 255),
      source: source?.substring(0, 255) || null,
    });

    if (navigator.sendBeacon) {
      navigator.sendBeacon(
        '/api/track/client-error',
        new Blob([payload], { type: 'application/json' })
      );
    } else {
      fetch('/api/track/client-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // Il reporting non deve mai rompere la pagina
  }
}

/**
 * Registra sul server gli errori JavaScript non gestiti del portfolio
 * (window.onerror e promise rejection non catturate).
 */
export function useClientErrorReporter() {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      const source = event.filename
        ? `${event.filename}:${event.lineno}:${event.colno}`
        : undefined;
      report('onerror', event.message || 'Errore sconosciuto', source);
    };

    const onRejection = (event: PromiseRejectionEvent) => {
      const reason = event.reason;
      const message =
        reason instanceof Error ? reason.message : String(reason ?? 'Rejection sconosciuta');
      report('unhandledrejection', message);
    };

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);
    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, []);
}
